import React, { useEffect, useRef, useState, useMemo } from 'react';
import { Container, Dropdown, Nav, Navbar, NavDropdown, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { urlConst } from '../../consts';
import { userActions } from '../../actions';
import logoImg from './assets/logo.png';
import { isCommentReaded } from '../../util';

function transformEventTitle(eventName) {
    const match = eventName.match(/^(.*) (\d\d\d\d)$/);
    if (!match) return eventName;
    return (
        <span className="position-relative">
            <span>{match[1]}</span>
            <span className="brand-event-year">{match[2]}</span>
        </span>
    );
}

function NotificationIcon() {
    const { requests, selfId } = useSelector((state) => ({
        requests: state.requests.requests,
        selfId: state.auth && state.auth.user && state.auth.user.id,
    }));
    const isVisible = useMemo(() => {
        if (!requests) return false;
        const allRequests = [...requests.author, ...requests.participant];
        return allRequests.some((request) => request.comments.some((comment) => !isCommentReaded(comment, selfId)));
    }, [requests, selfId]);
    return isVisible ? (
        <Nav.Link to={urlConst.REQUESTS} as={Link} className="mx-sm-2" title="Новые сообщения в заявках!">
            <FontAwesomeIcon icon={faBell} size="2x" className="mr-2 align-middle" shake />
        </Nav.Link>
    ) : null;
}

function AppBar(props) {
    const { user, logout, logined, logining, currentEvent } = props;
    const [expanded, setExpanded] = useState(false);
    const ref = useRef(null);

    const handleLogoutClick = (e) => {
        e.preventDefault();
        setExpanded(false);
        logout();
    };

    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setExpanded(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    return (
        <Navbar ref={ref} bg="dark" variant="dark" expand="sm" fixed="top" expanded={expanded}>
            <Container>
                <Navbar.Brand to={urlConst.MAIN} as={Link}>
                    <img src={logoImg} alt="Logo" width="32" className="mr-1" />
                    {(currentEvent && transformEventTitle(currentEvent.title)) || 'Феникс'}
                </Navbar.Brand>
                <Navbar.Toggle
                    aria-controls="basic-navbar-nav"
                    onClick={() => setExpanded(expanded ? false : 'expanded')}
                />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mr-auto align-items-center me-auto">
                        <Nav.Link
                            to={urlConst.PROGRAM}
                            as={Link}
                            className="mx-sm-2"
                            onClick={() => setExpanded(false)}
                        >
                            Программа
                        </Nav.Link>
                        <Nav.Link
                            to={urlConst.REQUESTS}
                            as={Link}
                            className="mx-sm-2"
                            onClick={() => setExpanded(false)}
                        >
                            Мои заявки
                        </Nav.Link>
                        <Nav.Link
                            to={urlConst.NEW_REQUEST}
                            as={Link}
                            className="mx-sm-2"
                            onClick={() => setExpanded(false)}
                        >
                            Создать заявку
                        </Nav.Link>
                    </Nav>
                    <Nav>
                        <NotificationIcon />
                        {logined ? (
                            <NavDropdown
                                id="user-profile-dropdown"
                                title={
                                    <>
                                        <FontAwesomeIcon icon={faUserCircle} size="2x" className="mr-2 align-middle" />
                                        {user.name || '??????'}
                                    </>
                                }
                            >
                                <Dropdown.Item to={urlConst.PROFILE} as={Link} onClick={() => setExpanded(false)}>
                                    Профиль
                                </Dropdown.Item>
                                <Dropdown.Item href={urlConst.LOGOUT} onClick={handleLogoutClick}>
                                    Выйти
                                </Dropdown.Item>
                            </NavDropdown>
                        ) : logining ? (
                            <Nav.Item>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    variant="light"
                                />
                            </Nav.Item>
                        ) : (
                            <Nav.Link to={urlConst.LOGIN} as={Link} onClick={() => setExpanded(false)}>
                                Войти
                            </Nav.Link>
                        )}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

function mapStateToProps(state) {
    const {
        auth: { user, logined, logining },
        events: { currentEvent },
    } = state;
    return { user, logined, logining, currentEvent };
}

const actionsToProps = {
    logout: userActions.logout,
};

export default connect(mapStateToProps, actionsToProps)(AppBar);
